var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="PopupHeader" style="height: '+
((__t=( headerHeight ))==null?'':__t)+
'px">\n	<div class="PopupDragArea">\n		<div class="PopupHeaderContent" style="height: '+
((__t=( headerHeight / 2 ))==null?'':__t)+
'px"></div>\n	</div>\n	<div class="PopupCloseButton" title="Schließen"><i class="fa fa-times"></i></div>\n</div>\n<div class="PopupContent ScrollContainer ScrollbarStyle" style="padding: '+
((__t=( contentPadding ))==null?'':__t)+
'px"></div>\n<!--<div class="PopupResizeArea nw"></div>-->\n<!--<div class="PopupResizeArea ne"></div>-->\n<!--<div class="PopupResizeArea sw"></div>-->\n<div class="PopupResizeArea se"></div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));
